import { connect } from 'react-redux';
import { createGanttView } from '../../common/gantt/containers/gantt-actions';
import CreateViewSidepanel from '../../worklist/components/toolbar/create-view-sidepanel';

const mapStateToProps = state => ({
  isSaving: state.gantt.isSavingViews,
  saveSuccess: state.gantt.saveViewsSuccess,
  error: state.gantt.error,
});

const mapDispatchToProps = {
  createView: createGanttView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateViewSidepanel);
